import React, { useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  CssBaseline,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  IconButton,
  useMediaQuery,
  Drawer
} from "@mui/material";
import {
  Dashboard,
  AddBoxOutlined,
  ExpandLess,
  ExpandMore,
  Menu,
  Group,
  GroupAdd,
  Edit,
  Lock,
  Description,
  ReceiptLong,
  Gavel,
  Logout,
  Language
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";
import { resetContact } from "../../redux/reducers/contactReducer";
import { resetHomeRe } from "../../redux/reducers/homeReducer";
import { paths } from "../../config/constants";
import { useDispatch,useSelector } from "react-redux";
import { reset } from "../../redux/reducers/login";
import axios from "axios";
import { Popover } from "@mui/material";
import { logoutUser } from "../../component/Elements/Session";
import useSessionTimeout from "../../component/Elements/useSessionTimeout";
import { useTranslation } from "react-i18next";

/* ================= WIDTH ================= */

const drawerWidthExpanded = 240;
const drawerWidthCollapsed = 70;

/* ================= STYLES ================= */

const SidebarContainer = styled(Box)(({ collapsed }) => ({
  width: collapsed ? drawerWidthCollapsed : drawerWidthExpanded,
  backgroundColor: "#0E4672",
  color: "#fff",
  display: "flex",
  flexDirection: "column",
  overflowX: "hidden",
  height: "100%"
}));

const StyledItem = styled(ListItemButton)(({ active }) => ({
  padding: "12px 20px",
  color: "#fff",
  borderLeft: active ? "4px solid #f16729" : "4px solid transparent",
  backgroundColor: active ? "#293846" : "transparent",
  "&:hover": {
    backgroundColor: "#293846",
    color: "#fff"
  }
}));

/* ================= SIDEBAR ================= */

function SidebarContent({ collapsed }) {
    let toastId1;
      let toastId2;
      let toastId3;
      let toastId4;
      let toastId5;
      let toastId6;
      let toastId7;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const reduxdata = useSelector((state) => state);
    const userId = reduxdata?.login?.user?.data?._id;
const [invoiceAnchor, setInvoiceAnchor] = useState(null);
const [termsAndPolicyAnchor, setTermsAndPolicyAnchor] = useState(null);
   let token = reduxdata?.login?.token;
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);
  const [bankInvoicelimit, setBankInvoiceLimit] = useState(0);
  const [isComissionNull,setIsComissionNull] = useState(null)
  const [isActive,setIsActive]= useState(null)
  const [accountType, setAccountType] = useState(null);
  const [role,setRole]=useState(null)
  const [active, setActive] = useState("dashboard");
  const [openInvoices, setOpenInvoices] = useState(false);
  const [openReports, setOpenReports] = useState(false);
const [reportsAnchor, setReportsAnchor] = useState(null);
const location = useLocation();
  const isCompany = role === "2" && accountType === "Company";
  const isAgent = role === "2" && accountType === "Agent";
    const [openTermsAndPolicies, setOpenTermsAndPolicies] = useState(false);
    const { i18n } = useTranslation();
const currentLang = i18n.language?.startsWith("de") ? "de" : "en";
const [openLanguage, setOpenLanguage] = useState(false);
const [languageAnchor, setLanguageAnchor] = useState(null);
useSessionTimeout();
  const handleLogout = async () => {
  await logoutUser({
    dispatch,
    navigate,
  });
};

const handleExpire = async () => {
  await logoutUser({
    dispatch,
    navigate,
    expired: true,
  });
};

const handleLangChange = (language) => {
  i18n.changeLanguage(language);
  setOpenLanguage(false);
  setLanguageAnchor(null);
};


     const fetchData = async () => {
    let obj = {
      userId: userId,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/getUserProfile`,
        obj
      );
      console.log(res?.data?.data);
      const profileCompleted = res?.data?.data?.isProfileCompleted;
      setIsProfileCompleted(res?.data?.data?.isProfileCompleted);
      setBankInvoiceLimit(res?.data?.data?.companyAgentLimit)
      setIsComissionNull(res?.data?.data?.companyAgentComission);
      setIsActive(res?.data?.data?.isUserActivated);
      setAccountType(res?.data?.data?.accountType);
      setRole(res?.data?.data?.role);
       // ✅ Set default active menu
    if (profileCompleted === false) {
      setActive("editProfile");
    } else {
      setActive("dashboard");
    }
    } catch (error) {}
  };

  useEffect(() => {
      fetchData();
    }, []);

  return (
    <SidebarContainer collapsed={collapsed}>

      {/* LOGO */}
      <Box
  onClick={() => {
    setActive("dashboard");   // reset active menu
    navigate(
      isCompany
        ? "/company/dashboard"
        : isAgent
        ? "/businessAgent/dashboard"
        : "/"
    );
  }}
        sx={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          cursor: "pointer"
        }}
      >
        <img
          src="https://blu.taxi/static/media/BLU%20TAXI%20white%20logo.4f586d7f9285146a885b.png"
          alt="Logo"
          style={{ width: collapsed ? 40 : 140 }}
        />
      </Box>

      <List>

        {/* ================= DASHBOARD ================= */}
       <StyledItem
  active={
    location.pathname === "/company/dashboard" ||
    location.pathname === "/businessAgent/dashboard"
  }
  onClick={() =>
    navigate(
      isCompany
        ? "/company/dashboard"
        : "/businessAgent/dashboard"
    )
  }
>
  <ListItemIcon sx={{ color: "#fff" }}>
    <Dashboard />
  </ListItemIcon>
  {!collapsed && <ListItemText primary="Dashboard" />}
</StyledItem>

        {/* ================= RIDE BOOKING ================= */}
       <StyledItem
  active={
    location.pathname === "/company/BussinessBooking" ||
    location.pathname === "/businessAgent/BussinessBooking"
  }
  onClick={(e) => {
    // Prevent navigation if profile is incomplete
    if (isProfileCompleted === false) {
      e.preventDefault();
      if (!toast.isActive(toastId1)) {
        toastId1 = toast.info(
          "You cannot book right now because your profile is incomplete please go to edit profile and complete it.",
          { autoClose: 2500 }
        );
      }
      return;
    }
    if ((isComissionNull === null || !isComissionNull) && isActive != "1") {
      e.preventDefault();
      if (!toast.isActive(toastId4)) {
        toastId4 = toast.info(
          "You cannot book right now because your commission has not yet been set and your account is inactive at the moment. Contact customer support.",
          { autoClose: 2500 }
        );
      }
      return;
    }
    if (isActive != "1") {
      e.preventDefault();
      if (!toast.isActive(toastId5)) {
        toastId5 = toast.info(
          "You cannot book right now because your account is inactive. Contact customer support.",
          { autoClose: 2500 }
        );
      }
      return;
    }

    // Prevent navigation if commission is not set
    if (isComissionNull === null || !isComissionNull) {
      e.preventDefault();
      if (!toast.isActive(toastId2)) {
        toastId2 = toast.info(
          "You cannot book right now because your commission has not yet been set. Contact customer support.",
          { autoClose: 2500 }
        );
      }
      return;
    }

    // Navigate only (NO setActive needed)
    navigate(
      isCompany
        ? "/company/BussinessBooking"
        : "/businessAgent/BussinessBooking"
    );
  }}
>
  <ListItemIcon sx={{ color: "#fff" }}>
    <AddBoxOutlined />
  </ListItemIcon>
  {!collapsed && <ListItemText primary="Create Booking" />}
</StyledItem>

        {/* ================= COMPANY ONLY ================= */}
        {isCompany && (
          <>
            <StyledItem
              active={
  location.pathname === paths.company.myStaff
}
              onClick={() => {
                setActive("staff");
                navigate("/company/my-staff");
              }}
            >
              <ListItemIcon sx={{ color: "#fff" }}>
                <Group />
              </ListItemIcon>
              {!collapsed && <ListItemText primary="Employee Manager" />}
            </StyledItem>

          <StyledItem
   active={
  location.pathname === paths.company.companyRegisterStaff
}
  onClick={(e) => {
    // Check if profile is completed
    if (isProfileCompleted === false) {
      e.preventDefault();
      if (!toast.isActive(toastId1)) {
        toastId1 = toast.info(
          "You cannot add employee right now because your profile is incomplete please go to edit profile and complete it.",
          { autoClose: 2500 }
        );
      }
      return;
    }

    if ((isComissionNull === null || !isComissionNull) && isActive != "1") {
      e.preventDefault();
      if (!toast.isActive(toastId6)) {
        toastId6 = toast.info(
          "You cannot book right now because your commission has not yet been set and your account is inactive at the moment. Contact customer support.",
          { autoClose: 2500 }
        );
      }
      return;
    }
    if (isActive != "1") {
      e.preventDefault();
      if (!toast.isActive(toastId7)) {
        toastId7 = toast.info(
          "You cannot book right now because your account is inactive. Contact customer support.",
          { autoClose: 2500 }
        );
      }
      return;
    }

    // Check if commission is set
    if (isComissionNull === null || isComissionNull === "") {
      e.preventDefault();
      if (!toast.isActive(toastId2)) {
        toastId2 = toast.info(
          "You cannot add employee right now because your commission has not yet been set. Contact customer support.",
          { autoClose: 2500 }
        );
      }
      return;
    }

    // Check if bank invoice limit is set
    if (bankInvoicelimit == null) {
      e.preventDefault();
      if (!toast.isActive(toastId3)) {
        toastId3 = toast.info(
          "You cannot add employee right now because your bank invoice limit has not yet been set.",
          { autoClose: 2500 }
        );
      }
      return;
    }

    // If all checks pass, proceed with navigation
    setActive("addStaff");
    navigate("/company/company-register-staff");
  }}
>
  <ListItemIcon sx={{ color: "#fff" }}>
    <GroupAdd />
  </ListItemIcon>
  {!collapsed && <ListItemText primary="Add Employee" />}
</StyledItem>
          </>
        )}

        {/* ================= EDIT PROFILE ================= */}
        <StyledItem
         active={
  location.pathname === "/company/edit-profile" ||
  location.pathname === "/businessAgent/edit-profile"
}
          onClick={() => {
            setActive("editProfile");
            navigate(
              isCompany
                ? "/company/edit-profile"
                : "/businessAgent/edit-profile"
            );
          }}
        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <Edit />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Edit Profile" />}
        </StyledItem>

        {/* ================= CHANGE PASSWORD ================= */}
        <StyledItem
         active={
  location.pathname === "/company/change-password" ||
  location.pathname === "/businessAgent/change-password"
}
          onClick={() => {
            setActive("password");
            navigate(
              isCompany
                ? "/company/change-password"
                : "/businessAgent/change-password"
            );
          }}
        >
          <ListItemIcon sx={{ color: "#fff" }}>
            <Lock />
          </ListItemIcon>
          {!collapsed && <ListItemText primary="Change Password" />}
        </StyledItem>

        {/* ================= INVOICES DROPDOWN ================= */}
     <StyledItem
  active={active === "bankInvoice" || active === "commissionInvoice"}
  onClick={(e) => {
    if (collapsed) {
      setInvoiceAnchor(e.currentTarget); // popup when collapsed
    } else {
      setOpenInvoices(!openInvoices); // expand when open sidebar
    }
  }}
>
  <ListItemIcon sx={{ color: "#fff" }}>
    <ReceiptLong />
  </ListItemIcon>

  {!collapsed && (
    <>
      <ListItemText primary="Invoices" />
      {openInvoices ? <ExpandLess /> : <ExpandMore />}
    </>
  )}
</StyledItem>

        <Collapse in={openInvoices && !collapsed} timeout="auto">
          <List component="div" disablePadding>

           <StyledItem
  active={active === "bankInvoice"}
  sx={{ pl: 6 }}
  onClick={() => {
    setActive("bankInvoice");
    navigate(
      isCompany
        ? "/company/CompanyBankInvoiceHistory"
        : "/businessAgent/AgentBankInvoiceHistory"
    );
  }}
>
              <ListItemText primary="Bank Invoice" />
            </StyledItem>

           <StyledItem
  active={active === "commissionInvoice"}
  sx={{ pl: 6 }}
  onClick={() => {
    setActive("commissionInvoice");
    navigate(
      isCompany
        ? "/company/CompanyCommissionInvoiceHistory"
        : "/businessAgent/AgentCommissionInvoiceHistory"
    );
  }}
>
              <ListItemText primary="Commission Invoice" />
            </StyledItem>

          </List>
        </Collapse>

        <Popover
  open={Boolean(invoiceAnchor)}
  anchorEl={invoiceAnchor}
  onClose={() => setInvoiceAnchor(null)}
  anchorOrigin={{
    vertical: "center",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "center",
    horizontal: "left",
  }}
  PaperProps={{
    sx: {
      backgroundColor: "#0E4672",
      color: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
    }
  }}
>
  <List sx={{ minWidth: 200 }}>

    <ListItemButton
      sx={{
        color: "#fff",
        "&:hover": { backgroundColor: "#293846" }
      }}
      onClick={() => {
        setActive("bankInvoice");
        setInvoiceAnchor(null);
        navigate(
          isCompany
            ? "/company/CompanyBankInvoiceHistory"
            : "/businessAgent/AgentBankInvoiceHistory"
        );
      }}
    >
      <ListItemText primary="Bank Invoice" />
    </ListItemButton>

    <ListItemButton
      sx={{
        color: "#fff",
        "&:hover": { backgroundColor: "#293846" }
      }}
      onClick={() => {
        setActive("commissionInvoice");
        setInvoiceAnchor(null);
        navigate(
          isCompany
            ? "/company/CompanyCommissionInvoiceHistory"
            : "/businessAgent/AgentCommissionInvoiceHistory"
        );
      }}
    >
      <ListItemText primary="Commission Invoice" />
    </ListItemButton>

  </List>
</Popover>

        {/* ================= REPORTS ================= */}
       <StyledItem
  active={
    isCompany
      ? location.pathname === paths.company.companyReport ||
        location.pathname === paths.company.customerReport ||
        location.pathname === paths.company.employeeReport
      : location.pathname === paths.businessAgent.ReportsPage
  }
  onClick={(e) => {
    if (!isCompany) {
      navigate(paths.businessAgent.ReportsPage);
      return;
    }

    if (collapsed) {
      setReportsAnchor(e.currentTarget);
    } else {
      setOpenReports(!openReports);
    }
  }}
>
  <ListItemIcon sx={{ color: "#fff" }}>
    <Description />
  </ListItemIcon>

  {!collapsed && (
    <>
      <ListItemText primary="Reports" />
      {isCompany &&
        (openReports ? <ExpandLess /> : <ExpandMore />)}
    </>
  )}
</StyledItem>


{isCompany && (
  <Collapse in={openReports && !collapsed}>
    <List component="div" disablePadding>

      <StyledItem
        sx={{ pl: 6 }}
        active={location.pathname === paths.company.companyReport}
        onClick={() => navigate(paths.company.companyReport)}
      >
        <ListItemText primary="My Booking Report" />
      </StyledItem>

      <StyledItem
        sx={{ pl: 6 }}
        active={location.pathname === paths.company.customerReport}
        onClick={() => navigate(paths.company.customerReport)}
      >
        <ListItemText primary="Customer Report" />
      </StyledItem>

      <StyledItem
        sx={{ pl: 6 }}
        active={location.pathname === paths.company.employeeReport}
        onClick={() => navigate(paths.company.employeeReport)}
      >
        <ListItemText primary="Employee Report" />
      </StyledItem>

    </List>
  </Collapse>
)}


{isCompany && (
  <Popover
    open={Boolean(reportsAnchor)}
    anchorEl={reportsAnchor}
    onClose={() => setReportsAnchor(null)}
    anchorOrigin={{
      vertical: "center",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "center",
      horizontal: "left",
    }}
    PaperProps={{
      sx: {
        backgroundColor: "#0E4672",
        color: "#fff",
        borderRadius: "8px",
      },
    }}
  >
    <List sx={{ minWidth: 220 }}>

      <ListItemButton
        onClick={() => {
          setReportsAnchor(null);
          navigate(paths.company.companyReport);
        }}
      >
        <ListItemText primary="My Booking Report" />
      </ListItemButton>

      <ListItemButton
        onClick={() => {
          setReportsAnchor(null);
          navigate(paths.company.customerReport);
        }}
      >
        <ListItemText primary="Customer Report" />
      </ListItemButton>

      <ListItemButton
        onClick={() => {
          setReportsAnchor(null);
          navigate(paths.company.employeeReport);
        }}
      >
        <ListItemText primary="Employee Report" />
      </ListItemButton>

    </List>
  </Popover>
)}



        {/* ================= TERMS ================= */}

{isCompany ? (
  <>
    {/* Parent for Company */}
    <StyledItem
      active={
        location.pathname === paths.company.termsAndCondition ||
    location.pathname === paths.company.cancellationPolicy
      }
      onClick={(e) => {
    if (collapsed) {
      setTermsAndPolicyAnchor(e.currentTarget); // popup when collapsed
    } else {
      setOpenTermsAndPolicies(!openTermsAndPolicies) // expand when open sidebar
    }
  }}
    >
      <ListItemIcon sx={{ color: "#fff" }}>
        <Gavel />
      </ListItemIcon>

      {!collapsed && (
        <>
          <ListItemText primary="Terms & Policies" />
          {openTermsAndPolicies ? <ExpandLess /> : <ExpandMore />}
        </>
      )}
    </StyledItem>

    <Collapse in={openTermsAndPolicies && !collapsed} timeout="auto">
      <List component="div" disablePadding>

        {/* Terms & Conditions */}
        <StyledItem
          active={location.pathname === paths.company.termsAndCondition}
          sx={{ pl: 6 }}
          onClick={() => {
navigate(paths.company.termsAndCondition);          }}
        >
          <ListItemText primary="Terms and Conditions" />
        </StyledItem>

        {/* Cancellation Policy */}
        <StyledItem
            active={location.pathname === paths.company.cancellationPolicy}
          sx={{ pl: 6 }}
          onClick={() => {
            navigate(paths.company.cancellationPolicy);
          }}
        >
          <ListItemText primary="Cancellation Policy" />
        </StyledItem>

      </List>
    </Collapse>

       <Popover
  open={Boolean(termsAndPolicyAnchor)}
  anchorEl={termsAndPolicyAnchor}
  onClose={() => setTermsAndPolicyAnchor(null)}
  anchorOrigin={{
    vertical: "center",
    horizontal: "right",
  }}
  transformOrigin={{
    vertical: "center",
    horizontal: "left",
  }}
  PaperProps={{
    sx: {
      backgroundColor: "#0E4672",
      color: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
    }
  }}
>
  <List sx={{ minWidth: 200 }}>

    <ListItemButton
      sx={{
        color: "#fff",
        "&:hover": { backgroundColor: "#293846" }
      }}
      onClick={() => { 
        setTermsAndPolicyAnchor(null);
       navigate(paths.company.termsAndCondition); }}
    >
      <ListItemText primary="Terms & Conditions" />
    </ListItemButton>

    <ListItemButton
      sx={{
        color: "#fff",
        "&:hover": { backgroundColor: "#293846" }
      }}
    onClick={() => { 
      setTermsAndPolicyAnchor(null);
     navigate(paths.company.cancellationPolicy); }}
    >
      <ListItemText primary="Cancellation Policy" />
    </ListItemButton>

  </List>
</Popover>
  </>
) : (
  /* Agent View - Direct Parent Item */
  <StyledItem
  active={location.pathname === paths.businessAgent.termsAndCondition}

onClick={() => {
  navigate(paths.businessAgent.termsAndCondition);
}}
  >
    <ListItemIcon sx={{ color: "#fff" }}>
      <Gavel />
    </ListItemIcon>

    {!collapsed && <ListItemText primary="Terms and Conditions" />}
  </StyledItem>
)}


{/* ================= LANGUAGE ================= */}
{/* <StyledItem
  active={openLanguage}
  onClick={(e) => {
    if (collapsed) {
      setLanguageAnchor(e.currentTarget);
    } else {
      setOpenLanguage(!openLanguage);
    }
  }}
>
  <ListItemIcon sx={{ color: "#fff" }}>
    <Language />
  </ListItemIcon>
  {!collapsed && (
    <>
      <ListItemText primary={`Language (${currentLang.toUpperCase()})`} />
      {openLanguage ? <ExpandLess /> : <ExpandMore />}
    </>
  )}
</StyledItem> */}

<Collapse in={openLanguage && !collapsed} timeout="auto">
  <List component="div" disablePadding>
    <StyledItem active={currentLang === "en"} sx={{ pl: 6 }} onClick={() => handleLangChange("en")}>
      <ListItemText primary="English" />
    </StyledItem>
    <StyledItem active={currentLang === "de"} sx={{ pl: 6 }} onClick={() => handleLangChange("de")}>
      <ListItemText primary="German" />
    </StyledItem>
  </List>
</Collapse>

<Popover
  open={Boolean(languageAnchor)}
  anchorEl={languageAnchor}
  onClose={() => setLanguageAnchor(null)}
  anchorOrigin={{ vertical: "center", horizontal: "right" }}
  transformOrigin={{ vertical: "center", horizontal: "left" }}
  PaperProps={{
    sx: { backgroundColor: "#0E4672", color: "#fff", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.3)" }
  }}
>
  <List sx={{ minWidth: 160 }}>
    <ListItemButton sx={{ color: "#fff", "&:hover": { backgroundColor: "#293846" } }} onClick={() => handleLangChange("en")}>
      <ListItemText primary="English" />
    </ListItemButton>
    <ListItemButton sx={{ color: "#fff", "&:hover": { backgroundColor: "#293846" } }} onClick={() => handleLangChange("de")}>
      <ListItemText primary="German" />
    </ListItemButton>
  </List>
</Popover>


        {/* ================= LOGOUT ================= */}
        <StyledItem onClick={handleLogout}>
          <ListItemIcon sx={{ color: "#ff4d4f" }}>
            <Logout />
          </ListItemIcon>
          {!collapsed && (
            <ListItemText primary="Logout" sx={{ color: "#ff4d4f" }} />
          )}
        </StyledItem>

      </List>
      
    </SidebarContainer>
    
  );
}

/* ================= MAIN LAYOUT ================= */

export default function CompanyLayout() {
const isMobile = useMediaQuery("(max-width:600px)");
const isTablet = useMediaQuery("(min-width:601px) and (max-width:1024px)");
const isLaptopOrAbove = useMediaQuery("(min-width:1025px)");
  const navigate = useNavigate();
  const username = localStorage.getItem("userName");
  const userId = localStorage.getItem("userID");
const role = localStorage.getItem("userRole");
const accountType = localStorage.getItem("accountType");
  const [collapsed, setCollapsed] = useState(false);
  const [mobileCollapsed, setMobileCollapsed] = useState(true);

const handleMenuClick = () => {
  if (isMobile || isTablet) {
    setMobileCollapsed(prev => !prev);
  } else {
    setCollapsed(prev => !prev);
  }
};

const getDashboardTitle = () => {

  if (role === "2") {
    if (accountType === "Company") return "Company Dashboard";
    if (accountType === "Agent") return "Agent Dashboard";
  }

  return "Dashboard";
};

  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />

  {/* DESKTOP / LAPTOP SIDEBAR */}
{isLaptopOrAbove && (
  <Box sx={{ width: collapsed ? drawerWidthCollapsed : drawerWidthExpanded }}>
    <SidebarContent collapsed={collapsed} />
  </Box>
)}

{/* MOBILE + TABLET DRAWER */}
{(isMobile || isTablet) && (
  <Drawer
    variant="temporary"
    open={!mobileCollapsed}
    onClose={() => setMobileCollapsed(true)}
    ModalProps={{ keepMounted: true }}
    sx={{
      "& .MuiDrawer-paper": {
        width: drawerWidthExpanded,
        backgroundColor: "#0E4672"
      }
    }}
  >
    <SidebarContent collapsed={false} />
  </Drawer>
)}

     <Box
       sx={{
         flexGrow: 1,
         display: "flex",
         flexDirection: "column",
         minWidth: 0
       }}
     >
      <Box
  sx={{
    height: 60,
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: 3,
    borderBottom: "1px solid #e5e5e5",
    position: "relative"
  }}
>
  <IconButton
    onClick={handleMenuClick}
    sx={{
      backgroundColor: "#f16729",
      color: "#fff",
      "&:hover": { backgroundColor: "#f16729" }
    }}
  >
    <Menu />
  </IconButton>

  {/* SHOW ONLY TABLET + LAPTOP */}
  {!isMobile && (
    <Box
      sx={{
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        fontWeight: 600,
        fontSize: { sm: 15, md: 16 },
        whiteSpace: "nowrap"
      }}
    >
      {getDashboardTitle()}
    </Box>
  )}

 <Box
  sx={{
    textAlign: "right",
    mr: { xs: 3, sm: 5, md: 0 }, 
    minWidth: 0
  }}
>
    <Box sx={{ fontSize: 15, fontWeight: 600 }}>
      {username}
    </Box>
    <Box sx={{ fontSize: 14 }}>
      ID: {userId}
    </Box>
  </Box>
</Box>

<Box
  component="main"
  sx={{
    flexGrow: 1,
    backgroundColor: "#f3f3f4",
    px: { xs: 2, sm: 3, md: 4 },
    py: 3,
    width: "100%",
    overflowX: "hidden"
  }}
>          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}